<template>
  <button class="favorite-button" @click="onClick">
    <FeatherIcon icon="heart" size="16" :class="iconClass" />
    <span class="text-size-14" :class="textColor" data-testid="favorite-text">{{
      text
    }}</span>
  </button>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

@Component({
  components: {
    FeatherIcon
  }
})
export default class FavoriteButton extends Vue {
  @Prop({
    required: true,
    type: Boolean
  })
  isFavorite!: boolean;

  get iconClass() {
    return this.isFavorite ? "active-icon" : "inactive-icon";
  }

  get textColor() {
    return this.isFavorite ? "text-gray-05" : "text-main";
  }

  get text() {
    return this.isFavorite ? "お気に入り済" : "お気に入り";
  }

  onClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.$emit("click", !this.isFavorite);
  }
}
</script>
<style lang="scss" scoped>
.favorite-button {
  display: flex;
  gap: 4px;
  align-items: center;
  min-width: 118px;
  height: 32px;
  padding: 6px 12px;
  background-color: $gray-02;
  border-radius: 100px;

  .active-icon {
    fill: #c2493e;
    stroke: #c2493e;
  }

  .inactive-icon {
    fill: transparent;
    stroke: #c2493e;
  }
}
</style>
